import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";

// Layout and Pages

import Layout from "./layout/Layout";
import Home from "./pages/Home";
import GlobalToast from "./components/toast/GlobalToast";
import PostCodeIssue from "./pages/PostCodeIssue";
import IssuesList from "./pages/CodeIssues";
import Profile from "./pages/Profile";
import About from "./pages/About";
import ContactPage from "./pages/Contact";
import EditCodeIssue from "./pages/EditCodeIssue";
import SingleIssuePage from "./pages/SingleIssuePage";
import ChatPage from "./pages/ChatPage";
import EditProfilePage from "./pages/EditProfile";
import ProjectForm from "./pages/EditProjects";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import AddSkills from "./pages/EditSkills";
import AddSocialLinks from "./pages/EditSocial";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ReferralJobForm from "./pages/ReffaralJobForm";
import ReferralJobsPage from "./pages/ReferralJobsPage";
import JobApplicationsPage from "./pages/JobApplications";
import MyReferralJobs from "./pages/MyReferralJobs";
import CreateMySkillsPage from "./pages/CreateMySkillsPage";
import DevelopersList from "./pages/DevelopersList";
import OneToOneChatPage from "./pages/SingleChatPage";
import DeveloperProfile from "./pages/DeveloperProfile";
import PostFreelanceProject from "./pages/PostFreelanceProject";
import FreelanceProjects from "./pages/FreelanceProjects";
import FreelanceProjectDetail from "./pages/FreelanceProjectDetail";
import MyProjects from "./pages/MyProjects";
import HowThisWorks from "./pages/HowThisWorks";
import AICareerHubPage from "./pages/AiCareerHub";
import PrepHome from "./pages/interview/PrepHome";
import ProfileInterview from "./pages/interview/ProfileInterview";
import ResultScreen from "./pages/interview/ResultScreen";
import QuestionsScreen from "./pages/interview/QuestionsScreen";
import AdminPanel from "./pages/admin/AdminPanel";
import AddInterviewPrep from "./pages/admin/AddInterviewPrep";
import InterviewPrepDetail from "./pages/admin/InterviewPrepDetail";

const Wrapper = styled.div`
  font-family: "Poppins", sans-serif;
  background-color: #000;
  color: #fff;
  min-height: 100vh;
`;

function App() {
  return (
    <Router>
      <Wrapper>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/post-code-issue"
            element={
              <Layout>
                <PostCodeIssue />
              </Layout>
            }
          />
          <Route path="/admin-panel" element={<AdminPanel />} />
          <Route path="/add-interview-prep" element={<AddInterviewPrep />} />
          <Route path="/interview-prep/:id" element={<InterviewPrepDetail />} />
          <Route
            path="/edit-code-issue/:id"
            element={
              <Layout>
                <EditCodeIssue />
              </Layout>
            }
          />
          <Route
            path="/code-issues"
            element={
              <Layout>
                <IssuesList />
              </Layout>
            }
          />
          <Route
            path="/code-issue/:id"
            element={
              <Layout>
                <SingleIssuePage />
              </Layout>
            }
          />
          <Route
            path="/profile/:id"
            element={
              <Layout>
                <Profile />
              </Layout>
            }
          />
          <Route
            path="/profile/edit/:id"
            element={
              <Layout>
                <EditProfilePage />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />

          <Route
            path="/contact-us"
            element={
              <Layout>
                <ContactPage />
              </Layout>
            }
          />

          <Route
            path="/chats"
            element={
              <Layout>
                <ChatPage />
              </Layout>
            }
          />
          <Route
            path="/how-this-works"
            element={
              <Layout>
                <HowThisWorks />
              </Layout>
            }
          />
          {/* <Route
            path="/ai-career-hub"
            element={
              <Layout>
                <AICareerHubPage />
              </Layout>
            }
          /> */}
          <Route
            path="/profile/edit/projects"
            element={
              <Layout>
                <ProjectForm />
              </Layout>
            }
          />
          <Route
            path="/profile/edit/skills"
            element={
              <Layout>
                <AddSkills />
              </Layout>
            }
          />
          <Route
            path="/profile/edit/socials"
            element={
              <Layout>
                <AddSocialLinks />
              </Layout>
            }
          />
          <Route
            path="/profile/edit/password"
            element={
              <Layout>
                <ChangePasswordPage />
              </Layout>
            }
          />

          <Route
            path="/forgot-password"
            element={
              <Layout>
                <ForgotPassword />
              </Layout>
            }
          />

          <Route
            path="/reset-password"
            element={
              <Layout>
                <ResetPassword />
              </Layout>
            }
          />
          <Route
            path="/post-referral-job"
            element={
              <Layout>
                <ReferralJobForm />
              </Layout>
            }
          />
          <Route
            path="/referral-jobs"
            element={
              <Layout>
                <ReferralJobsPage />
              </Layout>
            }
          />
          <Route
            path="/job-applications"
            element={
              <Layout>
                <JobApplicationsPage />
              </Layout>
            }
          />
          <Route
            path="/my-referral-jobs"
            element={
              <Layout>
                <MyReferralJobs />
              </Layout>
            }
          />
          <Route
            path="/create-myskills-page"
            element={
              <Layout>
                <CreateMySkillsPage />
              </Layout>
            }
          />
          <Route
            path="/members"
            element={
              <Layout>
                <DevelopersList />
              </Layout>
            }
          />
          <Route
            path="/post-freelance"
            element={
              <Layout>
                <PostFreelanceProject />
              </Layout>
            }
          />

          <Route
            path="/my-chats"
            element={
              <Layout>
                <OneToOneChatPage />
              </Layout>
            }
          />
          <Route
            path="/developers/:devId"
            element={
              <Layout>
                <DeveloperProfile />
              </Layout>
            }
          />
          <Route
            path="/freelance-projects"
            element={
              <Layout>
                <FreelanceProjects />
              </Layout>
            }
          />
          <Route
            path="/freelance-project/:id"
            element={
              <Layout>
                <FreelanceProjectDetail />
              </Layout>
            }
          />
          <Route
            path="/my-projects"
            element={
              <Layout>
                <MyProjects />
              </Layout>
            }
          />

          <Route
            path="/interview"
            element={
              <Layout>
                <PrepHome />
              </Layout>
            }
          />
          <Route
            path="/interview/:profileId"
            element={
              <Layout>
                <ProfileInterview />
              </Layout>
            }
          />
          <Route
            path="/interview/:profileId/questions"
            element={
              <Layout>
                <QuestionsScreen />
              </Layout>
            }
          />
          <Route
            path="/interview/:profileId/result"
            element={
              <Layout>
                <ResultScreen />
              </Layout>
            }
          />

          {/* Add more pages like Issues, Contact, etc., in the same way */}
        </Routes>
        <GlobalToast />
      </Wrapper>
    </Router>
  );
}

export default App;
